import React from "react";
import RechargeList from "./RechargeList";

const Recharges = () => {
  return (
    <div className="recharges-page-wrapper">
      <RechargeList />
    </div>
  );
};

export default Recharges;